import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components/macro";
import { Fetchable, isFetched } from "../../store/appState";
import ErrorList from "./ErrorList";

export interface StatusProps {
    loading: string;
    ok: string;
    error: string;
    data: Fetchable<any>;
}

export default function Status(props: StatusProps): JSX.Element {
    const data = props.data;

    return (<>
        {data && <div>
            {data.isFetching && <Loading>{props.loading}</Loading>}
            {data.hasErrors && <>
                <Error>{props.error}</Error>
                <ErrorList errors={data.errors} />
            </>}
            {isFetched(data) && <Success>{props.ok}</Success>}
        </div>}
    </>);
}

const Success = styled.div`
    margin: 3rem 0;
`;

const Loading = styled.div`
    margin: 3rem 0;
`;

const Error = styled.div`
    margin: 1rem 0 0 0;
    border: 0.6rem solid pink;
    padding: 1rem;
    border-radius: 0.2rem;
    background: red;
    color: white;
    display: inline-block;
`;